import { render, staticRenderFns } from "./Utenti.vue?vue&type=template&id=1d8e4d31&"
import script from "./Utenti.vue?vue&type=script&lang=js&"
export * from "./Utenti.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports